<template>
  <div class="carousel-container">
    <b-carousel class="mx-auto custom-carousel" id="carousel1" controls indicators background="#ababab" :interval="4000"
      v-model="slide" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
      <b-carousel-slide :img-src="require('@/assets/kn-Xorio.jpg')"></b-carousel-slide>
      <b-carousel-slide :img-src="require('@/assets/kn-Skiadi.jpg')"></b-carousel-slide>
      <b-carousel-slide :img-src="require('@/assets/kn-Goupa.jpg')"></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel-container {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px -5px rgba(2, 132, 199, 0.3);
  margin-bottom: 2rem;
  border: 4px solid #ffffff;
  /* white frame around images */
}

/* Remove 100% height to prevent collapsing. Force height onto the images directly */
::v-deep .carousel-item img {
  object-fit: cover !important;
  height: 400px !important;
  width: 100% !important;
}

::v-deep .carousel-control-prev-icon,
::v-deep .carousel-control-next-icon {
  width: 3rem;
  height: 3rem;
  background-color: rgba(2, 132, 199, 0.7);
  /* Greek blue semi-transparent backdrop */
  border-radius: 50%;
  background-size: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

::v-deep .carousel-indicators li {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 2px solid #0284c7;
  opacity: 0.6;
  margin: 0 6px;
}

::v-deep .carousel-indicators .active {
  opacity: 1;
  background-color: #0284c7;
}
</style>


// WEBPACK FOOTER //
// src/components/carousel.vue